import axios, { AxiosError, AxiosResponse } from 'axios';
import { getSimManagementErrorFromAxiosError } from '.';
import { PageParameters } from '../models/account';
import { QueryResult } from '../models/queryResult';
import { getApiBaseUrl } from '../services/helpers';

export function get(param: PageParameters): Promise<QueryResult<string>> {
  const { companyId, accountId } = param;
  const baseUrl = getApiBaseUrl(companyId, accountId);
  const url = `${baseUrl}userRole`;
  return new Promise<QueryResult<string>>((resolve, reject) => {
    axios
      .get(url)
      .then((response: AxiosResponse<QueryResult<string>>) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        reject(simManagementError);
      });
  });
}
